<template>
  <div class="container">
    <mad-form @submit.prevent="submit">
      <mad-form-item label="Typeform id">
        <mad-input v-model="form.typeform_id" />
      </mad-form-item>
      <mad-form-item label="Barcode">
        <image-input v-model="form.barcode" />
      </mad-form-item>

      <div class="spaced-row">
        <mad-button @click="clickCancel">
          <mad-icon mdi="arrow-left" />
        </mad-button>
        <div class="grow"></div>
        <mad-button color="brown" type="submit">
          <mad-icon mdi="check" />
          Create barcode
        </mad-button>
      </div>
    </mad-form>
  </div>
</template>

<script>
import ImageInput from '../inputs/ImageInput'

export default {
  components: {
    ImageInput,
  },

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    form: {
      typeform_id: '',
      barcode: '',
    },
  }),

  methods: {
    async submit() {
      await this.$store.dispatch('createForm', {
        ...this.form,
        location: { id: this.id },
      })
      this.$router.push(`/locations/${this.id}`)
    },
    clickCancel() {
      this.$router.push(`/locations/${this.id}`)
    },
  },
}
</script>

<style>
</style>
